import * as React from "react";
import { Alert, Card } from "antd";
import { CardTitle } from "../antd/card/CardTitle";
import { CardContent } from "../antd/card/CardContent";
import { v4 as uuidv4 } from "uuid";
import { CpArrayObject } from "../../pages/gvc/testNewForm/CpArrayObject";
import { CpArrayItemNameValuePair } from "../../pages/workload/draft/CpArrayItemNameValuePair";
import { CpErrorWarningArrayIcon } from "../../pages/gvc/testNewForm/CpErrorWarningArrayIcon";

export const CpTagsNew: React.FC = () => {
  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container" data-section-id="tags">
        <Card>
          <CardTitle>
            Tags
            <CpErrorWarningArrayIcon names={[`tags`]} />
          </CardTitle>
          <Alert
            type={"info"}
            message={"If value is a url, it will be clickable once created"}
            className="my-2"
            closable
          />
          <CardContent>
            <CpArrayObject
              name="tags"
              factoryFn={() => ({ id: uuidv4(), name: "", value: "" })}
              labels={["Key", "Value"]}
            >
              <CpArrayItemNameValuePair />
            </CpArrayObject>
          </CardContent>
        </Card>
      </div>
    </>
  );
};
